<template>
    <div class="flex flex-grow">
        <div class="h-[100vh] flex flex-col w-[80%]">
            <section
                class="
                    bg-white
                    py-4
                    px-2
                    flex
                    items-center
                    text-[20px]
                    font-bold
                    flex-grow-0 flex-shrink-0
                    gap-2
                    -[100]
                    w-full
                "
            >
                <a
                    :href="`/video?teamId=${
                        props.video.team_id ? props.video.team_id : ''
                    }`"
                    ><ion-icon name="arrow-back-outline"></ion-icon
                ></a>
                <h2 class="ml-2">{{ props.video.title }} - Video Editor</h2>
            </section>
            <div class="py-4 px-10">
                <div class="row">
                    <!-- Preview Video/Image -->
                    <div class="col-sm-12">
                        <video
                            ref="video"
                            @loadeddata="videoLoaded"
                            @timeupdate="videoTimeUpdate"
                            @pause="togglePause"
                            @play="togglePause"
                            loop
                            preload=""
                            poster=""
                            class="video-responsive"
                        >
                            <source :src="props.video.url" />
                        </video>
                    </div>
                </div>
                <!-- Timeline Container -->
                <div class="flex">
                    <!-- Play/Pause button -->
                    <div class="flex flex-column">
                        <button
                            title="Play/Pause Preview"
                            type="button"
                            class="btn btn-secondary timeline-btn"
                            @click="togglePlayback"
                        >
                            <svg
                                v-show="state.isPaused"
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="currentColor"
                                class="bi bi-play-fill"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
                                />
                            </svg>
                            <svg
                                v-show="!state.isPaused"
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="currentColor"
                                class="bi bi-pause-fill"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"
                                />
                            </svg>
                        </button>
                    </div>

                    <!-- Timeline w/ Clip Trimming -->
                    <div class="flex w-full">
                        <div
                            class="timeline"
                            ref="timeline"
                            @mousedown="seekToCursor($event)"
                            @mousemove="drag($event)"
                            @touchmove="drag($event)"
                            @mouseup="endDrag"
                            @touchend="endDrag"
                            @mouseleave="endDrag"
                        >
                            <div
                                title="Drag Playback Position"
                                ref="playhead"
                                class="playhead"
                                @mousedown="startDrag($event, 'playhead')"
                                @touchstart="startDrag($event, 'playhead')"
                                :style="{
                                    left: state.preview.position * 100.0 + '%',
                                }"
                            ></div>
                            <div
                                title="Drag to Trim Start"
                                ref="start"
                                class="marker marker_left"
                                @click="seekToMarker('start')"
                                @mousedown="startDrag($event, 'start')"
                                @touchstart="startDrag($event, 'start')"
                                :style="{
                                    left: state.preview.start * 100.0 + '%',
                                }"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="48"
                                    fill="currentColor"
                                    class="bi bi-grip-vertical"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                                    />
                                </svg>
                            </div>
                            <div
                                title="Drag to Trim End"
                                ref="end"
                                class="marker marker_right"
                                @click="seekToMarker('end')"
                                @mousedown="startDrag($event, 'end')"
                                @touchstart="startDrag($event, 'end')"
                                :style="{
                                    left:
                                        (state.preview.end -
                                            state.markerWidthPercent) *
                                            100.0 +
                                        '%',
                                }"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="48"
                                    fill="currentColor"
                                    class="bi bi-grip-vertical"
                                    viewBox="3 0 16 16"
                                >
                                    <path
                                        d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                                    />
                                </svg>
                            </div>
                            <div
                                ref="clip"
                                class="clip"
                                :style="{
                                    left: state.preview.start * 100.0 + '%',
                                    width: `calc(${
                                        (state.preview.end -
                                            state.preview.start) *
                                        100.0
                                    }%)`,
                                }"
                            >
                                {{ state.preview.length.toFixed(1) }} Seconds
                            </div>
                        </div>
                    </div>

                    <!-- Add Clip button -->
                    <div class="flex">
                        <button
                            title="Add Clip"
                            type="button"
                            class="btn btn-secondary timeline-btn pl-10"
                            @click="clipVideo"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="35"
                                height="35"
                                fill="currentColor"
                                class="bi bi-plus"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="
                w-[20%]
                px-4
                py-4
                bg-gray-100
                flex
                overflow-y-scroll
                h-[100vh]
            "
        >
            <div
                v-if="state.clips.length > 0"
                class="flex flex-col gap-8 relative"
            >
                <div
                    v-for="clip in state.clips"
                    :key="clip.id"
                    class="relative"
                >
                    <div class="bg-white py-1 px-1 flex justify-between">
                        <div></div>
                        <div
                            class="
                                text-[12px] text-center
                                bg-white
                                text-gray-500
                            "
                        >
                            {{ clip.title }}
                        </div>
                        <button class="text-red-500" @click="deleteClip(clip)">
                            <ion-icon
                                name="trash"
                                class="w-[20px] h-[20px]"
                            ></ion-icon>
                        </button>
                    </div>

                    <video controls playsinline :key="clip.url">
                        <source :src="clip.url" type="video/mp4" />
                    </video>
                </div>
            </div>
            <div class="text-gray-500 italic my-auto mx-auto" v-else>
                Add more clips by clicking "+" button
            </div>
        </div>
    </div>
    <ModalCustom
        :is-open="state.saveModalOpen"
        @close="tryCloseSaveModal"
        title="Save Video"
    >
        <div>
            <form method="post" @submit.prevent="saveClip">
                <app-input
                    maxlength="120"
                    name=""
                    placeholder="Video name (max 120 chars)"
                    type="text"
                    required
                    v-model="state.currentClip.title"
                ></app-input>
                <div class="mt-2">
                    <app-select
                        name="video_group_select"
                        v-model="state.currentClip.selectedVideoGroup"
                    >
                        <option
                            v-for="group in props.videoGroups"
                            :value="group.id"
                            :key="group.id"
                        >
                            {{ group.name }}
                        </option>
                    </app-select>
                </div>
                <div class="flex items-center mt-4 gap-4 justify-between">
                    <app-button
                        type="button"
                        class="flex-grow-0 flex-shrink-0"
                        @click="tryCloseSaveModal"
                    >
                        Cancel
                    </app-button>
                    <app-button
                        type="submit"
                        :disabled="state.isSaving"
                        class="flex-grow-0 flex-shrink-0 bg-primary text-white"
                    >
                        Save
                    </app-button>
                </div>
            </form>
        </div>
    </ModalCustom>
</template>

<script setup>
import { defineProps, onMounted, reactive, ref } from "vue";
import { randomString } from "../utils/string";

const video = ref("");
const playhead = ref("");
const clip = ref("");
const timeline = ref("");

const props = defineProps({
    editorApi: {
        type: String,
    },
    video: {
        type: Object,
        required: true,
    },
    videoGroups: {
        type: Array,
        required: true,
    },
    disk: {
        type: String,
    },
    folder: {
        type: String,
    },
    group: {
        type: String,
    },
});

const state = reactive({
    isLoading: true,
    isPaused: true,
    draggingMarker: null,
    markerWidthPercent: 0.0,
    preview: {
        file: null,
        clip: null,
        start: 0.0,
        end: 1.0,
        position: 0.0,
        length: 0.0,
    },
    clips: [],

    currentClip: null,
    saveModalOpen: false,
    isSaving: false,
});

function trypOpenSaveModal(clip) {
    state.saveModalOpen = true;
    state.currentClip = clip;
    if (props.videoGroups && props.videoGroups.length > 0) {
        state.currentClip.selectedVideoGroup = props.videoGroups[0].id;
    }
}

function tryCloseSaveModal() {
    if (!state.isSaving) {
        state.saveModalOpen = false;
        state.currentClip = null;
    }
}

function togglePause() {
    if (video) {
        state.isPaused = video.value?.paused;
    }
}

function findClipIndex(id) {
    return state.clips.findIndex((clip) => clip.identifier == id);
}

async function deleteClip(item) {
    state.clips = state.clips.filter((clip) => clip.id != item.id);

    await axios.post(`/video/delete-api`, {
        id: item.id,
    });
}

async function clipVideo() {
    const identifier = randomString(10);

    const startTime =
        state.preview.start * fixImageDuration(video.value?.duration);
    const endTime = state.preview.end * fixImageDuration(video.value?.duration);
    var start = secondsToTime(startTime);
    var end = secondsToTime(endTime);
    var duration = secondsToTime(endTime - startTime);

    state.clips = [
        ...state.clips,
        {
            identifier,
            title: `Clip ${start} - ${end}`,
            isClipping: true,
        },
    ];

    const resp = await axios.post(`${props.editorApi}/clip`, {
        url: props.video.url,
        start,
        duration,
        identifier,
        group: props.group,
        folder: props.folder,
    });

    const clip = await axios.post("/video/save-clip", {
        title: `Clip ${start} - ${end}`,
        filepath: resp.data.filepath,
        thumbnail_path: resp.data.thumbnail_path,
        video_group_id: props.video.video_group_id,
        size: resp.data.size,
        team_id: props.video.team_id,
        user_id: props.video.user_id,
        source_video_id: props.video.id,
        disk: props.disk,
        parent_video_id: props.video.id,
    });

    const clipIndex = findClipIndex(identifier);
    if (clipIndex != -1) {
        state.clips[clipIndex].url = resp.data.url;
        state.clips[clipIndex].isClipping = false;
        state.clips[clipIndex].id = clip.data.videoId;
    }
}

function videoLoaded() {
    if (video) {
        video.currentTime = state.preview.start;
        setPreview({
            start: 0,
            end: 1,
            length: fixImageDuration(video?.value.duration),
        });
    }
}

function videoTimeUpdate() {
    if (video) {
        let playback_percent = video.currentTime / video.value?.duration;
        if (!video.paused && playback_percent >= state.preview.end) {
            video.currentTime = state.preview.start * video.value?.duration;
        }
        // Update playback %, because it might have changed
        playback_percent = video.value?.currentTime / video.value?.duration;
        setPreviewPosition(playback_percent);
    }
}

function setPreview(payload) {
    state.preview.start = payload.start;
    state.preview.end = payload.end;
    if (state.preview && video) {
        state.preview.length =
            (state.preview.end - state.preview.start) *
            fixImageDuration(video?.value.duration);
    }
}

function fixImageDuration(duration) {
    if (duration == 3600) {
        return 30;
    } else {
        return duration;
    }
}

function setPreviewPosition(position) {
    state.preview.position = position;
}

function togglePlayback() {
    if (video) {
        if (video.value?.paused) {
            video.value?.play();
            state.isPaused = false;
        } else {
            video.value?.pause();
            state.isPaused = true;
        }
    }
}

function startDrag(e, marker) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    if (video) {
        video.value?.pause();
    }
    state.draggingMarker = marker;
}
function endDrag() {
    state.draggingMarker = null;
}
function seekToCursor(e) {
    if (!state.draggingMarker) {
        let percent_x = getCursorPosition(e);
        if (video) {
            video.value.currentTime = percent_x * video.value?.duration;
        }
        return false;
    }
}
function seekToMarker(marker) {
    if (video) {
        if (marker == "start") {
            video.value.currentTime =
                state.preview.start * video.value?.duration;
        } else if (marker == "end") {
            video.value.currentTime = state.preview.end * video.value?.duration;
        }
    }
}
function drag(e) {
    checkClipSize();
    if (state.draggingMarker == "start") {
        setPreview({
            start: Math.min(getCursorPosition(e), state.preview.end),
            end: state.preview.end,
        });
        if (video && isFinite(state.preview.start * video.value?.duration)) {
            video.value.currentTime =
                state.preview.start * video.value?.duration;
        }
    } else if (state.draggingMarker == "end") {
        setPreview({
            start: state.preview.start,
            end: Math.max(getCursorPosition(e, 12), state.preview.start),
        });
        if (video && isFinite(state.preview.start * video.value?.duration)) {
            video.value.currentTime = state.preview.end * video.value?.duration;
        }
    } else if (state.draggingMarker == "playhead") {
        let percent_x = getCursorPosition(e);
        playhead.style.left = `${percent_x * 100}%`;
        if (video && isFinite(state.preview.start * video.value?.duration)) {
            video.value.currentTime = percent_x * video.value?.duration;
        }
    }
}
function getMarkerWidth() {
    if (timeline) {
        return state.markerWidth / timeline.clientWidth;
    } else {
        return 0.0;
    }
}
function getCursorPosition(e, x_offset = 0) {
    let timeline_bounds = timeline.value?.getBoundingClientRect();
    let x = x_offset;

    // Get X coordinate
    if (
        e.type == "touchstart" ||
        e.type == "touchmove" ||
        e.type == "touchend" ||
        e.type == "touchcancel"
    ) {
        let touch = e.touches[0] || e.changedTouches[0];
        x += touch.clientX;
    } else if (
        e.type == "click" ||
        e.type == "mousedown" ||
        e.type == "mouseup" ||
        e.type == "mousemove" ||
        e.type == "mouseover" ||
        e.type == "mouseout" ||
        e.type == "mouseenter" ||
        e.type == "mouseleave"
    ) {
        x += e.clientX;
    }

    // Clamp to parent bounds
    if (x < timeline_bounds.left) {
        x = timeline_bounds.left;
    } else if (x + 12 - x_offset > timeline_bounds.right) {
        x = timeline_bounds.right - 12 + x_offset;
    }

    // Convert position to percentage of timeline width
    let relative_x = x - timeline_bounds.left;
    let percent_x = relative_x / timeline_bounds.width;
    return percent_x;
}

function checkClipSize() {
    if (clip && clip.clientWidth < 80) {
        state.clipMessage = "clip-too-small";
    } else {
        state.clipMessage = "";
    }
}

async function loadVideo() {
    await axios.post(`${props.editorApi}/load`, {
        url: props.video.url,
    });

    state.isLoading = false;
}

async function loadClips() {
    try {
        const clips = await axios.get(`/video/list-clips?id=${props.video.id}`);
        state.clips = clips.data;
    } catch (e) {}
}

onMounted(() => {
    loadVideo();
    loadClips();
});
function secondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const milliseconds = Math.round((seconds % 1) * 1000);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
    )}:${String(secs).padStart(2, "0")}.${String(milliseconds).padStart(
        3,
        "0"
    )}`;
}
</script>

<style scoped>
video {
    background-color: #000000;
    width: 100%;
}
.timeline {
    background-color: #000000;
    height: 48px;
    position: relative;
    flex-grow: 1;
}
.marker {
    color: #ffffff;
    background-color: #0d6efd;
    height: 48px;
    width: 12px;
    position: absolute;
    cursor: ew-resize;
    z-index: 10;
}
.clip {
    background-color: #0d6efd;
    height: 48px;
    position: absolute;
    z-index: 0;
    color: #ffffff;
    font-size: 0.7em;
    text-align: center;
    padding-top: 15px;
}
.clip-too-small {
    color: #0d6efd !important;
    padding-top: 47px !important;
}

.playhead {
    background-color: #ffffff;
    width: 3px;
    height: 48px;
    position: absolute;
    cursor: grab;
    z-index: 100;
    opacity: 0.8;
}
.timeline-btn {
    background-color: #0d6efd;
    height: 48px;
    width: 100%;
    padding: 0.15em;
    color: white;
}
.btn-secondary {
    padding-left: 1rem;
    padding-right: 1rem;
}
.img-thumbnail {
    width: 100% !important;
}
.spinner-border {
    margin-top: 100px;
    width: 4em;
    height: 4em;
}
.spinner-container {
    min-height: 300px;
}
.sidebar {
    box-shadow: -2px 2px 11px 2px rgba(0, 0, 0, 0.2);
}
</style>
